import { render, staticRenderFns } from "./problemStudentAnswerList.vue?vue&type=template&id=be423020&scoped=true"
import script from "./problemStudentAnswerList.vue?vue&type=script&lang=js"
export * from "./problemStudentAnswerList.vue?vue&type=script&lang=js"
import style0 from "./problemStudentAnswerList.vue?vue&type=style&index=0&id=be423020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be423020",
  null
  
)

export default component.exports